












import { Component, Vue, Prop } from 'vue-property-decorator';
import { MerchantDomain, ServiceVersion, ServiceVersionInput } from '@/types';
import UpTags from '../Common/UpTags.vue';
import { merchantSvc } from '@/services';
import { Message } from 'element-ui';
import { Action } from 'vuex-class';

@Component({
  name: 'service-versions',
  components: {
    UpTags
  }
})
export default class ServiceVersions extends Vue {
  @Prop({ required: true })
  private versions!: ServiceVersion[];

  @Prop({ required: true, type: String })
  private serviceId!: string;

  private isLoading: boolean = false;

  @Action
  createServiceVersion!: (
    version: ServiceVersionInput
  ) => Promise<ServiceVersion>;

  async deleteVersion(version: ServiceVersion) {
    Message.warning('Service Version can not be deleted.');
  }

  async addVersion(tag: string) {
    this.isLoading = true;
    await this.createServiceVersion({ tag, serviceId: this.serviceId });
    this.isLoading = false;
  }
}
